// extracted by mini-css-extract-plugin
export var box = "Checkbox-module--box--da8f6";
export var box_md = "Checkbox-module--box_md--69f0e";
export var box_xmd = "Checkbox-module--box_xmd--2cfb7";
export var box_flex = "Checkbox-module--box_flex--6019b";
export var box_lg = "Checkbox-module--box_lg--4cc72";
export var box_sm = "Checkbox-module--box_sm--a5fd8";
export var box_outer = "Checkbox-module--box_outer--8bec3";
export var box_whiteBg = "Checkbox-module--box_white-bg--85a20";
export var box_noMarginBottom = "Checkbox-module--box_no-margin-bottom--a16ac";
export var box_noPadding = "Checkbox-module--box_no-padding--d6a92";
export var box_outerGray = "Checkbox-module--box_outer-gray--0d22e";
export var box_dark = "Checkbox-module--box_dark--e7e4c";
export var box_zIndex = "Checkbox-module--box_z-index--cc9c5";
export var box_zIndex6 = "Checkbox-module--box_z-index-6--d0070";
export var box_eventsWithLine = "Checkbox-module--box_events-with-line--e2b4f";
export var box_featuresAo = "Checkbox-module--box_features-ao--eb8d7";
export var box_verticalPaddings = "Checkbox-module--box_vertical-paddings--4d394";
export var clearP = "Checkbox-module--clearP--bf578";
export var clearP_vc = "Checkbox-module--clearP_vc--79ee0";
export var checkbox = "Checkbox-module--checkbox--f5a37";
export var square = "Checkbox-module--square--61798";
export var lg = "Checkbox-module--lg--8af35";
export var content = "Checkbox-module--content--c7171";
export var md = "Checkbox-module--md--43fff";
export var sm = "Checkbox-module--sm--5370b";
export var input = "Checkbox-module--input--ac454";
export var fadeInAnimation = "Checkbox-module--fadeInAnimation--6b462";
export var placeHolderShimmer = "Checkbox-module--placeHolderShimmer--64ced";